// @ts-nocheck

export const COST_PER_GRID = 1.0;
export const HISTORY_PAGE_SIZE = 20;
export const GRID_STORAGE_KEY = 'grid:basket:open-pools';
